import React from 'react';

import type { TextAdConditions } from '../../util/text-ads-util';
import { isBingEnabled } from '../initialisation-util';
import ExternallyPopulatedTag from '../../../components/externally-populated-tag';

export const BingSlotDivNames = {
    bingTop: 'bing-top',
    bingBottom: 'bing-bottom',
} as const;

export const BingSlotAttributionNames = {
    bingTopAttribution: `${BingSlotDivNames.bingTop}-attribution`,
    bingBottomAttribution: `${BingSlotDivNames.bingBottom}-attribution`,
};

export const BingSlotContainerNames = {
    top: `${BingSlotDivNames.bingTop}-container`,
    bottom: `${BingSlotDivNames.bingBottom}-container`,
};

export type BingSlotDivName = typeof BingSlotDivNames[keyof typeof BingSlotDivNames];

export const BingTopSlot = (textAdConditions: TextAdConditions) => {
    return isBingEnabled(textAdConditions) ? (
        <div id={BingSlotContainerNames.top} style={{ display: 'grid', margin: '8px 0' }}>
            <div id={BingSlotAttributionNames.bingTopAttribution} style={{ marginLeft: '16px' }} />
            <div style={{ display: 'flex', overflowX: 'auto', marginBottom: '24px' }}>
                <ExternallyPopulatedTag tagId={BingSlotDivNames.bingTop} />
            </div>
        </div>
    ) : (
        <></>
    );
};

export const BingBottomSlot = (textAdConditions: TextAdConditions) => {
    return isBingEnabled(textAdConditions) ? (
        <div id={BingSlotContainerNames.bottom}>
            <div
                id={BingSlotAttributionNames.bingBottomAttribution}
                style={{ marginLeft: '16px' }}
            />
            <ExternallyPopulatedTag tagId={BingSlotDivNames.bingBottom} />
        </div>
    ) : (
        <></>
    );
};
